import React, { useState, useEffect } from "react";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddProductPrice from "./AddProductPrice";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "productId", label: "Product ID" },
  { id: "salesPrice", label: "Sales Price" },
  { id: "effectiveDate", label: "Effective Date" },
  { id: "activeStatus", label: "Active Status" },
  { id: "createdAt", label: "Created At" },
  { id: "createdBy", label: "Created By" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function Product({
  productList,
  DeleteProductSalesPrice,
  LoadProductSalesPrice,
  LoadProducts,
  productSalesPrice,
  AddProduct,
  companyId,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(productSalesPrice, headCells, filterFn);

  useEffect(() => {
    LoadProducts(companyId);
    LoadProductSalesPrice();
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.product.name.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addProductSalesPrice = (product, resetForm) => {
    var data = { ...product };
    AddProduct(data);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const onDelete = (id) => {
    DeleteProductSalesPrice(id);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };

  function formatAmount(amount) {
    const roundedAmount = Math.floor(amount * 100) / 100;
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(roundedAmount);
  }

  return (
    <>
      <div
        className="container"
        style={{ paddingTop: "1rem", marginTop: "-5rem" }}
      >
        <Column flexGrow={1}>
          <ToastContainer />
          <div className="mt-5 pr-4">
            <Controls.Input
              placeholder="Search Products Sales Price by Product Name"
              className={classes.searchInput}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
          </div>
          <Paper className={classes.pageContent}>
            <h4>
              <strong>Product Sales Price</strong>
            </h4>
            <Toolbar>
              <Controls.Button
                text="Add New"
                variant="outlined"
                startIcon={<AddIcon />}
                className={classes.newButton}
                onClick={() => {
                  setAddOpenPopup(true);
                  setRecordForEdit(null);
                }}
              />
            </Toolbar>
            <TblContainer>
              <TblHead />
              <TableBody>
                {recordsAfterPagingAndSorting().map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.product.name}</TableCell>
                    <TableCell>₦{formatAmount(item.salesPrice)}</TableCell>
                    <TableCell>
                      {new Date(item.effectiveDate).toLocaleString()}
                    </TableCell>
                    <TableCell>{item.activeStatus.toString()}</TableCell>
                    <TableCell>
                      {new Date(item.createdAt).toLocaleString()}
                    </TableCell>
                    <TableCell>
                      {item.createdBy.firstName} {item.createdBy.lastName}
                    </TableCell>
                    <TableCell>
                      <Controls.ActionButton
                        color="secondary"
                        onClick={() => {
                          setConfirmDialog({
                            isOpen: true,
                            title: "Are you sure to delete this record?",
                            subTitle: "You can't undo this operation",
                            onConfirm: () => {
                              onDelete(item.id);
                            },
                          });
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </Controls.ActionButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </Paper>

          <Popup
            title="Add Product Sales Price Form"
            openPopup={addOpenPopup}
            setOpenPopup={setAddOpenPopup}
          >
            <AddProductPrice
              recordForEdit={recordForEdit}
              addOrEdit={addProductSalesPrice}
              productsDropdown={productList}
            />
          </Popup>
          <Notification notify={notify} setNotify={setNotify} />
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Column>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    user: state.userReducer.user,
    products: state.productReducer.products,
    productSalesPrice: state.productSalesPriceReducer.productSalesPrice,
    productList: state.productReducer.productList,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdateProduct(payload) {
    dispatch({ type: "UPDATE_PRODUCT", payload });
  },

  AddProduct(payload) {
    dispatch({ type: "ADD_PRODUCT_SALES_PRICE", payload });
  },
  LoadProductSalesPrice(payload) {
    dispatch({ type: "LOAD_PRODUCT_SALES_PRICE", payload });
  },
  LoadProductsDropdown(payload) {
    dispatch({ type: "LOAD_PRODUCTS", payload });
  },
  LoadProducts(payload) {
    dispatch({ type: "LOAD_PRODUCT", payload });
  },

  DeleteProductSalesPrice(payload) {
    dispatch({ type: "DELETE_PRODUCT_SALES_PRICE", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Product);
